module.exports = __webpack_public_path__ + "static/img/2.648ad21d.png";